import {FC, useContext, useEffect, useMemo, useState} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
} from '../../../../../../_metronic/helpers'
import {SubscriptionPlan, SubscriptionPlansQueryResponse} from './_models'
import {useQueryRequest} from './QueryRequestProvider'
import {getRequest} from '../../../../../../setup/redux/common/cruds'
import {AxiosResponse} from 'axios'
import {extractSignificantFiltersFromQuery} from '../../../../../services/Functional'

const QueryResponseContext = createResponseContext<SubscriptionPlan>(initialQueryResponse)

type QueryResponseProviderProps = {
  children: React.ReactNode
}

const QueryResponseProvider: FC<QueryResponseProviderProps> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const significantFilters = extractSignificantFiltersFromQuery(query)

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.SUBSCRIPTION_PLANS_LIST}-${query}`,
    () => {
      return getRequest(
        `${process.env.REACT_APP_API_BASE_URL}inspection_companies/enterprise/query/list?${query}`
      ).then((d: AxiosResponse<SubscriptionPlansQueryResponse>) => d.data)
    },
    {
      enabled: significantFilters.length > 0,
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }
  // @ts-ignore
  return response?.data?.inspection_companies || []
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {QueryResponseProvider, useQueryResponse, useQueryResponseData, useQueryResponseLoading}
